import { all, call, put, select, takeEvery } from "redux-saga/effects";

import {
  getPostIgnoreTopStart,
  getPostIgnoreTopFailed,
  getPostIgnoreTopSuccess,
} from "../redux/getPostRemaining";

import { getPostRemainApi } from "core/http/service/internalEvents";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { PayloadAction } from "@reduxjs/toolkit";

function* getPostIgnoreTopWork(
  action: PayloadAction<{
    id: string;
    awardId: string;
    sort: string;
    limit?: string | number;
    offset?: string | number;
  }>
) {
  const { id, ...payload } = action.payload;
  const { offset, limit } = yield select(controlInfinitiveScrollSelector(null));
  const params = {
    topLimit: 3,
    offset,
    limit,
    ...payload,
  };

  try {
    const res = yield call(getPostRemainApi, params);

    yield put({
      type: getPostIgnoreTopSuccess.type,
      payload: {
        id,
        data: res.data,
        totalRecords: res.totalRecords,
      },
    });
  } catch (error: any) {
    yield put({
      type: getPostIgnoreTopFailed.type,
      payload: {
        id,
      },
    });
  }
}

function* watchGetPostIgnoreTop() {
  yield takeEvery(getPostIgnoreTopStart.type, getPostIgnoreTopWork);
}

export default function* getVoteGetPostIgnoreTopSaga() {
  yield all([watchGetPostIgnoreTop()]);
}
